import PositionMod from './position.js';
var MODULE_NAME = 'ui.bootstrap.module.position';
let compMod = angular.module(MODULE_NAME, [PositionMod]);
export default compMod = compMod.name;
